import { render, staticRenderFns } from "./BusinessApplication.vue?vue&type=template&id=5daaf4ad&"
import script from "./BusinessApplication.vue?vue&type=script&lang=js&"
export * from "./BusinessApplication.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports